// extracted by mini-css-extract-plugin
export default {"deleteIcon":"BackgroundTableRow_deleteIcon__ci1BU"};